/* eslint-disable @typescript-eslint/no-explicit-any */
import Cookie from 'js-cookie'
import { get } from 'lodash-es'

const COOKIE_KEY = 'session'

export const createSession = (
  authToken: string,
  refreshToken: string,
  user?: any,
  language?: any,
) => {
  Cookie.set(
    COOKIE_KEY,
    JSON.stringify({ authToken, refreshToken, user, language }),
  )
}

export const getSessionValue = (key: string, defaultValue: any) =>
  get(JSON.parse(Cookie.get(COOKIE_KEY) || '{}'), key, defaultValue)

export const destroySession = () => {
  Cookie.remove(COOKIE_KEY)
}
